export const routes = {
    home: '/',
    navigation_item: '/navigation-item/:navItemId',
    login: '/login',
    users: '/users'
};
